import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { FC, useState } from 'react';
import { oceanProConsultationUrl } from '../../config/pageConfig';

interface NavProps {
    theme?: 'black' | 'white';
}
const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();

    const { t } = useLang('OceanProHomeSolarBattery');

    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: '/ocean-pro-home-solar-battery',
                label: t(`nav_overview`),
                href: '/ocean-pro-home-solar-battery',
            },
            // {
            //     value: 'EcoFlow APP',
            //     label: t(`nav_ecoFlow`),
            //     href: `https://homebattery.ecoflow.com/eu/hems/ecoflow-app`,
            // },
            {
                value: '/ocean-pro-home-solar-battery/faq',
                label: t(`nav_FAQ`),
                href: `/ocean-pro-home-solar-battery/faq`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t(`nav_schedule`),
                href: oceanProConsultationUrl,
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'product_navigation',
                    navigation_name: t(`nav_schedule`),
                    product_name: t(`nav_logo_text`),
                },
            },
        ],
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: '/ocean-pro-home-solar-battery',
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={router?.pathname || ''}
                theme={theme}
            />
        </div>
    );
};

export default Nav;
